import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class WorkingSlotsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // CREATE //
  createSuccess() {
    const message = {
      body: 'WORKING_SLOTS_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError(error) {
    const message = {
      body: 'WORKING_SLOTS_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateOneSuccess() {
    const message = {
      body: 'WORKING_SLOTS_UPDATE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateOneError(error) {
    const message = {
      body: 'WORKING_SLOTS_UPDATE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteOneSuccess() {
    const message = {
      body: 'WORKING_SLOTS_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }
  deleteOneError(error) {
    const message = {
      body: 'WORKING_SLOTS_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  validateWorkingSlotsError(error) {
    const message = {
      body: 'WORKING_SLOTS_VALIDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
}

angular
  .module('bringoz.admin.working-slots')
  .service('workingSlotsAlerts', WorkingSlotsAlerts);
